import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import { Button, TextField } from "@material-ui/core";
import Http from "../../../Http";
import './Depositos.css';
import ACCESS from "../../../ACCESS.js";

class Depositos extends TableComponent {
  componentDidMount() {
    const { params } = this.props.match;
    this.tableConfig(
      {
        dataUrl: `pago-deposito/filter/${params.id}`,
        deleteUrl: "pago-deposito/delete",
        deleteField: "importe",
        modUrl: "/Cobranza/Deposito",
      },
      TableOp.Table(
        "Dépositos",
        [
          { label: "Linea", id: "linea" },
          { label: "Importe", id: "importe" },
          { label: "Identificado", id: "identificado" },
          { label: "Plazo", id: "plazo" },
          { label: "Sucursal", id: "sucursal" },
          { label: "Cliente", id: "cliente_rsocial" },
        ],
        [
          { id: "identificar_deposito", icon: "edit", tooltip: 'identificar', access: [ACCESS.COBRANZA_CONTROL_DEPOSITO.IDENTIFICAR_DEPOSITO] },
          { id: 'delete', icon: 'delete', access: [ACCESS.COBRANZA_CONTROL_DEPOSITO.ELIMINAR_DEPOSITO] },
        ]
      )
    );
    this.table();
    this.getPago();
  }

  action = async (id, row) => {
    if (id === "identificar_deposito") {
      this.props.history.push(`/Cobranza/Deposito/${row.id}`);
    } if (id === 'delete') {
      await this.delete(row);
		}
  }

  dialogClose = async (op) => {
		this.setState({ dialog: { ...this.state.dialog, show: false } })
		if (op === 1) {
			let Res = await Http.post(`${this.config.deleteUrl}`, this.deleteRow);
			if (!Res.error) {
				await this.table();
				await this.getPago();
			}
		}
	}

  getPago = async () => {
    const { params } = this.props.match;
    const Res = await Http.get(`pago/one/${params.id}`);
    if (!Res.error) {
      this.setState({ pago: Res.data });
    }
  };

  onAddRow = async () => {
    const { tableData, importe } = this.state;
    const { rows } = tableData;
    this.setState({ loadingAdd: true });
    if (parseFloat(importe) > 0) {
      const newRow = {
        importe,
        identificado: "NO",
        plazo: "",
        sucursal: "",
      };
      rows.push(newRow);
      this.setState({ rows, importe: 0.0 });
      await this.saveDeposito(newRow);
      this.setState({ loadingAdd: false });
    }
  };

  saveDeposito = async (deposito) => {
    const { id } = this.props.match.params;
    deposito.id_pago = id;
    if (!this.context.hasAccess([ACCESS.COBRANZA_CONTROL_DEPOSITO.CREAR_DEPOSITO])) {
      return;
    }
    const Resp = await Http.post(`pago-deposito/save`, deposito);
    if (!Resp.error) {
      this.table();
    }
  };

  render() {
    const { importe, pago, loadingAdd } = this.state;
    const { hasAccess } = this.context;
    return (
      <div className="row">
        <div className="col-sm-12">
          {pago &&
            <div className="header" >
              {/* <div className="cuenta"> BANORTE 1954</div> */}
              <div className="dep-field" >
                <span className="title" >Folio:</span> {pago.id}
              </div>
              <div className="dep-field" >
                <span className="title">Fecha Déposito:</span> {pago.fecha_deposito}
              </div>
              <div className="dep-field" >
                <span className="title">Importe Total:</span> {pago.importe_total}
              </div>
              {/* <div className="dep-field" >
                <span className="title">Linea de Captura:</span> {pago.linea}
              </div> */}
            </div>
          }
          {hasAccess(ACCESS.COBRANZA_CONTROL_DEPOSITO.CREAR_DEPOSITO) && (
          <div className="add-deposito" >
            <TextField
              type="number"
              style={{ marginRight: 5 }}
              placeholder="Importe"
              variant="outlined"
              value={importe}
              onChange={(e) => this.setState({ importe: e.target.value })}
            />
            <Button onClick={() => { this.onAddRow() }} variant="contained" color="primary" disabled={loadingAdd} >
              Agregar
            </Button>
          </div>
          )}
        </div>
        <div className="col-sm-12">
          <this.TableRender />
        </div>
      </div>
    );
  }
}

export default withRouter(Depositos);
